import React from "react";

const HeroBanner = ({ title, subTitle, desc }) => {
  return (
    <div className="welcome-to service">
      <div className="container">
        <div className="welcome-caption">
          <strong>{title}</strong>
          <h3>{subTitle}</h3>
          <p>{desc}</p>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
